<template>
  <Layout>
    <template #external>
      <SideBar />
    </template>

    <template #internal>
      <TopBar
        v-if="$route.meta?.topBar"
        :title-option="{ title: $route.meta?.title }"
        :back-option="{ backOption: $route.meta?.backOption }"
        :comm="comm"
      />
      <AppMain v-slot="{ Component, route }" :comm="comm">
        <keep-alive :max="10" :include="routeInclude">
          <WujieVue
            v-if="route.meta?.isApp"
            :key="route.meta.appName"
            :name="route.meta.appName"
            :props="{
              useSystemData: useSystemData,
            }"
            :alive="true"
            :path="getAppPath()"
            width="100%"
            height="100%"
          />
          <component v-else-if="!route.meta?.cache" :is="Component" :key="route.name" @set-top="comm?.set" />
          <component v-else :is="Component" :key="route.fullPath" @set-top="comm?.set" />
        </keep-alive>
      </AppMain>
    </template>
  </Layout>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { Layout, AppMain, TopBar, topComm } from '@fe/zxwy-utils/layout/v3-arco'

import { useLayoutStore } from '@/store/modules/layout'
import { appEnum } from '@/tool/appConfig'

import SideBar from './SideBar/index.vue'
import {usePermissionStore} from '@/store/modules/permission'
import {useUserStore} from '@/store/modules/user'

export default {
  name: 'LayoutCom',
  components: {
    Layout,
    SideBar,
    TopBar,
    AppMain
  },
  computed: {
    ...mapState(useLayoutStore, ['routeInclude']),
    ...topComm(),
    settingVisible() {
      return this.$route.meta?.setting
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (!this.$route.meta.cache) return
        this.addCacheView(this.$route)
      }
    }
  },
  methods: {
    useUserStore, usePermissionStore,
    ...mapActions(useLayoutStore, ['addCacheView']),
    useSystemData() {
      const permissionStore = usePermissionStore()
      const userStore = useUserStore()

      return {
        authInstance: permissionStore.authInstance,
        userName: userStore.userName,
        deptName: userStore.deptName,
        deptId: userStore.deptId,
        avatar: userStore.avatar,
        userId: userStore.userId,
        sex: userStore.sex,
        phone: userStore.phone
      }
    },
    getAppPath() {
      const appName = this.$route.meta?.appName

      if (!appName) {
        return this.$route.fullPath
      }
      const app = appEnum[appName]

      if (!app) {
        return this.$route.fullPath
      }
      const path = 'path' in app ? app.path : app.name

      if (!path) {
        return this.$route.fullPath
      }
      // 移除当前路由完整路径中的应用路径前缀
      return this.$route.fullPath.replace(`/${path}`, '')
    }
  }
}
</script>

<style lang="less" scoped>
.layout_container {
  width: 100%;
  height: 100%;
  background-color: var(--color-fill-1);
}
.app_main {
  padding: 0 !important;
}
</style>
